export default __webpack_public_path__ + "static/media/yarn.20176999.svg";